import { ref } from 'vue'
import { defineStore } from 'pinia'
import { api } from '@/api'
import type Webinar from '@/api/resources/webinars/model'

export const useWebinarsStore = defineStore('webinars', () => {
  const webinars = ref<Webinar[]>([])
  let lastFetchTime: number | null = null

  const fetch = async (noCache = false) => {
    if (!noCache && lastFetchTime && Date.now() - lastFetchTime < 1000 * 2) {
      // less than 2 seconds
      return webinars.value
    }

    webinars.value = await api.webinars.list()
    lastFetchTime = Date.now()
    return webinars.value
  }

  return {
    fetch,
    webinars,
  }
})
